import Moment from 'react-moment';

const DateFormatYearMonth = (props) => {
  
    return <Moment format="MMM D, YYYY">{props?.date}</Moment>;

}

export default DateFormatYearMonth